import Vue from 'vue'
import axios from 'axios';
import Qs from 'qs';
import config from '@config';
const nodeEnv = process.env.NODE_ENV;
var baseUrl = config[nodeEnv].apiHost;  

//申请应用开发
export const doadd = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/feedback/doadd', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

// export const domodifyPassword = (ctx, params) => {
//   console.log('domodifyPassword params  ', params)
//   return new Promise((resolve, reject) => {
//     axios.post(baseUrl+api.domodifyPassword, [function (data) {
//       // 对 data 进行任意转换处理
//       return Qs.stringify(data)
//     }], {
//         'Authorization': axios.defaults.headers.common['Authorization']
//       }, params).then((res) => {
//         if (res.data.code == 0) {
//           resolve(res.data.data)
//         } else {
//           reject(res)
//         }
//       })
//   })
// };
export const domodifyPassword = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios({
      url: baseUrl+api.domodifyPassword,
      method: 'post',
      transformRequest: [function (data) {
        // 对 data 进行任意转换处理
        return Qs.stringify(data)
      }],
      data: params
    }).then((res) => {

      if (res.status == 200) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//分页获取科研调查列表
export const researchList = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/getListPage', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//删除科研调查
export const researchDel = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/del/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//根据id获取科研调查详情（带问题和答案)
export const researchDetail = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/detail/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//根据id获取科研调查详情（不带问题和答案)
export const researchDetailMain = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/detailMain/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//结题科研调查
export const researchEnd = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/end/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//暂停科研调查
export const researchPause = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/pause/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//启动科研调查
export const researchStart = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/start/' + params.id + '?isPublic=' + params.isPublic, ).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//不公开科研调查
export const researchPrivate = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/private/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//公开科研调查
export const researchPublic = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/public/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取科研调查二维码
export const researchQrcode = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/qrcode/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取科研调查高清二维码
export const researchQrcodeHD = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/qrcodeHD/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取列表系统推荐图片列表
export const GetPicList = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/getListPicList', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取详情系统推荐图片列表
export const getDetailPicList = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/getDetailPicList', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//保存科研调查
export const researchSave = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/save/', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//更新科研调查
export const researchUpdeta = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/updata/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//图片上传
export const FileUpload = (ctx, params) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.instance.post('/researchInfo/fileUpload', params).then((res) => {
      if (res.data.success) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//文件上传
export const FileUpload2 = (ctx, params) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.instance.post('/researchInfo/fileUpload2 ', params).then((res) => {
      if (res.data.success) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//文件积分查询
export const GetCurrentBalance = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/getCurrentBalance', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//根据当前用户获取科研调查列表
export const researchGetCurrentListPage = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/getCurrentListPage', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取项目ID，科研项目WJ开头
export const researchGetResearchId = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/getResearchId', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//分页获取问题列表
export const questionsGetListPage = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/questions/getListPage', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};


//根据当前用户分页获取问题列表
export const questionsGetCurrentListPage = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/questions/getCurrentListPage', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//根据问题id获取详情
export const questionsDetail = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/questions/detail/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//删除问题
export const questionsDel = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/questions/del/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取项目ID，科研项目WJ开头
export const questionsGetID = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/questions/getId', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取预设问题分类
export const getPreQuestionCatalog = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/questions/getPreQuestionCatalog', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//根据预设问题分类获得预设问题
export const getPreQuestionsByCatalog = (ctx, data) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/questions/getPreQuestionsByCatalog/' + data.id, {
      params: {
        pageIndex: data.pageIndex,
        pageSize: data.pageSize,
        content: data.content
      }
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//配置问题答案
export const questionsAnswer = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/questions/question/answer', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//保存问题
export const questionsSave = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/questions/save', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//更新问题
export const questionsUpdate = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/questions/update', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
export const getPlanList = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchPlan/getList', {
      params: data
    }).then((res) => {
      if (res.data.code == 0) {
        commit("getPlanList", res.data.data);
        resolve(res.data.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
export const getPlanDetails = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchPlan/get', {
      params: data
    }).then((res) => {
      if (res.data.code == 0) {
        commit("getPlanDetail", res.data.data);
        resolve(res.data.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
export const setPlanStatus = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchPlan/setStatus', {
      params: data
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res)
      } else {
        reject(res)
      }
    }).catch(err => {
      if (err.response.data) {
        reject(err.response)
      }
    })
  })
};
export const planPrivate = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+"/researchPlan/private/" + data).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
export const planPublic = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+"/researchPlan/public/" + data).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
export const getPlanCode = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchPlan/getCode', {
      params: data
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
export const deletePlan = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.delete(baseUrl+'/researchPlan/delete', {
      params: data
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
export const addPlan = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchPlan/add', {
      params: data
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//获取科研计划二维码
export const researchPlanQrcode = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchPlan/qrcode/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//获取科研计划进展分页列表
export const getProgressList = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchProgress/getList', {
      params: data
    }).then((res) => {
      if (res.data.code == 0) {
        commit("getProgressList", res.data.data);
        resolve(res.data.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//获取某个科研计划本月剩余可推送进展次数
export const getPushTimes = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchProgress/getPushTimes', {
      params: data
    }).then((res) => {
      if (res.data.code == 0) {
        commit("getPushTimes", res.data.data);
        resolve(res.data.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//删除科研计划进展
export const deletePlanProgress = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.delete(baseUrl+'/researchProgress/delete?progressId=' + data).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//增加科研计划进展
export const addPlanProgress = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios({
      url: baseUrl+"/researchProgress/add",
      method: 'post',
      transformRequest: [function (data) {
        // 对 data 进行任意转换处理
        return Qs.stringify(data)
      }],
      params: data
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch(err => {
      if (err.response.data) {
        reject(err.response)
      }
    })
  })
};

export const getResearchInfoList = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/targetedDelivery/getResearchInfoListPage', {
      params: data
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
export const getResearchPlanList = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/targetedDelivery/getResearchPlanListPage', {
      params: data
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//新增科研计划
export const researchPlanAdd = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchPlan/add/', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//修改科研计划
export const researchPlanUpdate = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchPlan/update', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//获取某个科研计划或科研调查本月剩余群发投放次数
export const getDeliveryPushTimes = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/targetedDelivery/getPushTimes', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//定向投放取已投放列表获取接口
export const getDeliveryListPage = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/targetedDelivery/getDeliveryListPage', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//群发投放
export const targetedDeliveryPush = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/targetedDelivery/push', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//根据问题类型编号数据元分页查询,返回问题列表
export const getQuestionsByTypeContent = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/questions/getQuestionsByTypeContent', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//根据问题类型分页查询,返回问题列表
export const getQuestionsByType = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/questions/getQuestionsByType', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//根据科研调查id获得问题列表
export const getResearchQuestionsById = (ctx, params) => {
  return new Promise((resolve, reject) => {
    var param = {
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
      keyword: params.keyword
    }
    axios.get(baseUrl+'/researchInfo/getResearchQuestions/' + params.id, {
      params: param
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//从科研调查中移除问题
export const removeQuestionFromResearch = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/removeQuestionFromResearch', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//获取志愿者管理列表
export const getVolunteerList = ({
  commit
}, data) => {
  var headers = {
    headers: {
      "Content-Type": 'application/json;charset=UTF-8'
    }
  }
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/volunteers/getPageList', {
      params: data
    }, headers).then((res) => {
      if (res.data.code == 0) {
        commit("getVolunteerList", res.data.data);
        resolve(res.data.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//批量更新问题排序
export const batchUpdateQuestionOrder = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/questions/batchUpdateQuestionOrder/' + params.id, params.qvs).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//根据问题id查询答案列表
export const getAnswerById = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/questions/getAnswer/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取志愿者问卷完成进度
export const getInfoStatus = ({
  commit
}, data) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/volunteers/getInfoStatus', {
      params: data
    }).then((res) => {
      if (res.data.code == 0) {
        commit("getInfoStatus", res.data.data);
        resolve(res.data.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//删除问题答案
export const delAnswer = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/questions/delAnswer', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//将问题添加到科研调查中
export const batchAddQuestionToResearch = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/batchAddQuestionToResearch/' + params.id, params.params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//志愿者出租
export const changeVolunteerOut = ({
  commit
}, data) => {
  var headers = {
    headers: {
      "Content-Type": 'application/json;charset=UTF-8'
    }
  }
  return new Promise((resolve, reject) => {
    axios.delete(baseUrl+'/volunteers/out', {
      params: data
    }, headers).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch(err => {
      if (err.response.data) {
        reject(err.response)
      }
    })
  })
};

//批量更新答案排序
export const batchUpdateAnswers = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/questions/batchUpdateAnswers', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//获得调查问卷的数据,可以指定一二级分类
export const getResearchData = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/getResearchData', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//获得指定层次数据分类,用于获得数据类别,level=1,数据分类level=2
export const getDataCatalog = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/getDataCatalog', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//添加或者更新调查问卷数据
export const addOrUpdateResearchData = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/addOrUpdateResearchData', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//删除调查问卷数据项
export const delResearchData = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/delResearchData/' + params.rdId).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//更新科研调查
export const updateResearchInfo = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/update', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取科研计划下属科研调查
export const getPlanInfoList = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchPlan/getPlanInfoList', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//获取答案id
export const getAnswerId = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/questions/getAnswerId', {
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//获取预设问题详情
export const getQusetDetail = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/questions/detail/' + id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//申请科研数据
export const applyForRearchInfoData = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/applyForRearchInfoData/' + id, {}).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//查看科研调查数据下载链接接口
export const applyRearchDataRecord = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/applyRearchDataRecord/' + id, {}).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//下载科研数据文件
export const downLoadResearchInfoData = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/downLoadResearchInfoData/' + id, {}).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//导出统计结果文件
export const exportStatistics = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/exportStatistics/' + id, {}).then((res) => {
      resolve(res.data)
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//查询科研调查启动状态
export const checkStartStatus = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/checkStartStatus/' + id, {}).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//刷新二维码
export const refreshQrcode = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/refreshQrcode/' + params.id + '?type=' + params.type, {}).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取上传文件签名
export const uploadFileSign = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/upload/fileSign/' + id, {}).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取上传状态
export const uploadQueryStatus = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/upload/queryStatus', {
      params: {
        taskId: id
      }
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取上传文件回调方法
export const uploadCallBack = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/upload/callBack/', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//更改上传状态
export const chgUploadStatus = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/upload/chgUploadStatus').then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取基分奖励额度
export const getCreditLimit = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/getCreditLimit').then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//更新科研调查奖励
export const updateReward = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/updateReward', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取当前问卷已发放积分
export const getUsedCredit = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/getUsedCredit/'+id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};
//获取原型应用列表
export const getPhenotypeAppList = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/getPhenotypeAppList').then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//更新科研调查回收
export const updateRecoverySetting = (ctx, params) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+'/researchInfo/updateRecoverySetting', params).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取科研调查统计详情
export const getStatistics = (ctx, id) => {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/statistics/'+id).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};

//获取科研调查统计详情
export const getStatisticsQuestion = (ctx, params) => {
  console.log(params)
  return new Promise((resolve, reject) => {
    axios.get(baseUrl+'/researchInfo/statistics/question/'+params.id,{
      params: params
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }).catch((res) => {
      reject(res.data)
    })
  })
};


// WEBPACK FOOTER //
// ./src/store/actions.js